export default __webpack_public_path__ + "static/media/automation.8bc0ed10.svg";